import React from 'react'
import ReactDOM from 'react-dom'

interface Props {
  children: any
  to?: string
}

const Portal: React.FC<Props> = ({ children, to }) => {
  if (to) {
    const ele = document.querySelector(to)
    if (ele) {
      return ReactDOM.createPortal(children, ele)
    }
  }
  return ReactDOM.createPortal(children, document.body)
}

export default Portal
